






















import { Component, Mixins } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderMain from "@/components/AppHeader/AppHeaderMain.vue";
import StudentsTable from "@/components/StudentsTable/StudentsTable.vue";
import TableToolbar from "@/components/TableToolbar/TableToolbar.vue";
import StickyListHeader from "@/components/StickyListHeader/StickyListHeader.vue";

import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";
import Alert from "@/components/BaseAlert/BaseAlert.vue";

import RequestState from "@/utils/mixins/RequestState";

import EventBus from "@/utils/helpers/EventBus";
import { Action, State } from "vuex-class";
import { IStudent } from "@/models/interfaces/students";
import { IVuexState } from "@/models/interfaces/store";

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderMain,
    StudentsTable,
    TableToolbar,
    StickyListHeader,

    Spinner,
    Alert
  }
})
export default class StudentsView extends Mixins(RequestState) {
  @Action("students/fetchStudents")
  private fetchStudents!: () => Promise<{ students: IStudent[] }>;

  @State("students", { namespace: "students" })
  private students!: IVuexState<IStudent[]>;

  public mounted() {
    this.fetchStudents();
  }
}
